export default __webpack_public_path__ + "static/media/img_1.30d7b7bb.png";